<template>
  <div>
    <div class="col float-right">
      <q-btn-group outline>
        <q-btn v-if="this.tabParam.documentStatusCd" class="custom-btn" label="QR 코드" icon="arrow_circle_down" color="black" size="md">
          <q-popup-proxy>
            <c-card title="QR 코드 출력" class="cardClassDetailForm">
              <template slot="card-button">
                <q-btn label="인쇄" icon="save" color="blue" @click="print" />
              </template>
              <template slot="card-detail">
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <div class="wrap" action="#" id="printJS-form">
                      <vue-qrcode
                        :value="'https://www.google.com/'" 
                        :options="{ width: 180 }"
                        class="canvas"
                      >
                      </vue-qrcode>
                      <span class="facilityStyle">
                        <p class="abc" >
                          <b>{{'-교육명 : '}}</b>{{tabParam.educationName}}
                          <br>
                          <b>{{'-교육일시 : '}} </b>{{tabParam.educationDate}}
                        </p>
                      </span>
                    </div>
                  </div>
                </div>
              </template>
            </c-card>
          </q-popup-proxy>
        </q-btn>
        <c-btn  v-show="editable&&!disabled" :showLoading="false" label="교육계획결재" icon="save" color="blue" @btnClicked="planComplete('APPR')" />
        <c-btn  v-show="editable&&!disabled" :showLoading="false" label="계획완료" icon="save" color="blue"  @btnClicked="planComplete('COMPLETE')" />
      </q-btn-group>
    </div>
    <c-tab
      type="vertical"
      :tabItems="tabItems"
      :height.sync="height"
      v-model="tab"
    >
      <template v-slot:default="tab">
        <component
          :is="tab.component"
          :tabParam="tabParam"
          :param="param"
          @transInfo="transInfo"
        />
      </template>
    </c-tab>
  </div>
</template>

<script>
import { uid } from 'quasar'
import printJs from 'print-js'
import VueQrcode from '@chenfengyuan/vue-qrcode';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'education-plan-tab',
  components: {
    VueQrcode
  },
  props: {
    param: {
      type: Object,
      default: () => ({
        eduEducationId: '',
      }),
    },
    height: {
      type: String,
      default: function() {
        return '';
      },
    },
  },
  data() {
    return {
      tabParam: {
        eduEducationId: '',
        educationName: '',
        eduCourseId: '',
        plantCd: '',
        educationYear: '',
        educationCourseName: '',
        educationKindCdLarge: null,
        educationKindCdSmall: null,
        educationTypeCd: null,
        departmentDeptCd: '',
        legalEducationFlag: null,
        educationTime: '',
        educationCycle: null,
        educationPurpose: '',
        relationLaws: '',
        mainTargetAudience: '',
        educationMonth: null,
        educationLocation: '',
        estimatedEducationExpenses: '',
        executionBudget: '',
        educationStartDate: '',
        educationEndDate: '',
        educationStartTime: '',
        educationEndTime: '',
        instructorInformation: '',
        sopMocId: '',
        educationMethodCd: null,
        educationOverview: '',
        evaluationEvalCd: '',
        documentStatusCd: '',
        qrCodeRoute: '',

        regUserId: '',
        chgUserId: '',
        eduSubjectList: [], // 과정별 교육과목
        eduAttendeeList: [],
      },
      saveCall: {
        saveCallData: '',
      },
      editable: true,
      splitter: 5,
      tab: 'educationPlanInfo',
      
      isComplete: false,
      insertUrl: '',
      deleteUrl: '',
      updateUrl: '',
    };
  },
  computed: {
    disabled() {
      return this.tabParam.documentStatusCd !== 'ESC000001'
    },
    tabItems() {
      return [
        { name: 'educationPlanInfo', icon: 'edit', label: '기본정보', component: () => import(`${'./educationPlanInfo.vue'}`) },
        { name: 'educationTargetUser', icon: 'how_to_reg', label: '교육대상자', component: () => import(`${'./educationResultTargetUser.vue'}`), disabled: (this.param.eduEducationId ? false : true) },
        { name: 'educationTextBook', icon: 'checklist', label: '교육교재', component: () => import(`${'./educationTextBook.vue'}`), disabled: (this.param.eduEducationId ? false : true) },
        // { name: 'educationQuestion', icon: 'manage_search', label: '교육문제', component: () => import(`${'./educationQuestion.vue'}`) },
      ]
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      // url setting
      this.insertUrl = transactionConfig.sop.edu.plan.insert.url;
      this.updateUrl = transactionConfig.sop.edu.plan.update.url;
      this.completeUrl = transactionConfig.sop.edu.annual.complete.url;
      // code setting
      // list setting
    },
    print() {
      printJs({
        printable: 'printJS-form',
        type: 'html',
        font_size: '20px',
        targetStyles: ['*'],
      })
    },
    transInfo(data) {
      this.tabParam = data;
    },
    planComplete(type) {
      let content = '';
      if (type === 'COMPLETE') content = '계획완료'
      else content = '결재'
      let flag = false;
      if (!flag) {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: content + '하시겠습니까?(저장과 함께 처리됩니다.)',
          // TODO : 점검완료 하시겠습니까?
          type: 'warning', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.tabParam.documentStatusCd = 'ESC000005'
            this.$http.url = this.completeUrl;
            this.$http.type = 'PUT';
            this.$http.param = this.tabParam;
            this.$http.request(() => {
              window.getApp.$emit('APP_REQUEST_SUCCESS');
              this.saveCall.saveCallData = uid();
              if (this.tabParam.documentStatusCd === 'ESC000005') {
                this.$emit('emitStep', {
                  name: 'currentStep',
                  param: 'ESC0000010' // 교육결과로 이동
                })
              }
            },);
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
      });
      }
    },
  }
};
</script>
